module.exports = __webpack_public_path__ + "static/media/bandeiras.f68feda3.png";